import { useCallback, useMemo, useState } from "react";
import { createContext } from "react";
import Toast from "../components/atoms/toast";

const ToastContext = createContext({});

export const ToastProvider = ({ children }) => {
    const [bToast, setBToast] = useState(false);
    const [gToast, setGToast] = useState(false);
    const [message, setMessage] = useState("");

    const goodToast = useCallback((text) => {
        setMessage(text);
        setGToast(true);
    }, []);

    const badToast = useCallback((text) => {
        setMessage(text);
        setBToast(true);
    }, []);

    const value = useMemo(
        () => ({
            goodToast,
            badToast,
        }),
        [goodToast, badToast]
    );

    return (
        <ToastContext.Provider value={value}>
            {children}
            <Toast toast={gToast} setToast={setGToast} colors="bg-green-600" text={message} />
            <Toast toast={bToast} setToast={setBToast} colors="bg-red-600" text={message} />
        </ToastContext.Provider>
    );
};

export default ToastContext;
